import { useMutation } from "@apollo/client";
import { EMAIL_CHANNEL_UPDATE } from "graphql/mutation/email-channel-gql";
import { GET_EMAIL_CHANNELS_CURSOR } from "graphql/query/email-channel-gql";
import {
  errorNotification,
  successNotification,
} from "components/request-result";

const useMutationEmailChannelCreateUpdate = (
  id: string | undefined,
  variables: Record<string, any>
) => {
  const [setEmailChannel, { loading }] = useMutation(EMAIL_CHANNEL_UPDATE, {
    onError(error) {
      errorNotification(error);
    },
  });

  const _setEmailChannelCreateUpdate = async (options: {
    variables: Record<string, any>;
    mutationID?: string | null;
    notifySuccess?: boolean;
    refetch?: boolean;
  }) => {
    const {
      mutationID,
      notifySuccess = true,
      refetch = true,
      ...mutationOptions
    } = options;
    const outerID = mutationID === null ? undefined : mutationID ?? id;
    const shouldRefetch = refetch && Boolean(variables?.first);
    const mutationVariables = {
      id: outerID,
      ...options.variables,
    };

    const result = await setEmailChannel({
      ...mutationOptions,
      variables: mutationVariables,
      refetchQueries: shouldRefetch
        ? [{ query: GET_EMAIL_CHANNELS_CURSOR, variables }]
        : [],
      awaitRefetchQueries: shouldRefetch,
    });

    if (notifySuccess) {
      const { label, message } = result.data?.emailChannelUpdate ?? {};
      successNotification({ title: label, description: message });
    }

    return result;
  };

  return {
    _setEmailChannelCreateUpdate,
    loadingMutationEmailChannelCreateUpdate: loading,
  };
};

export default useMutationEmailChannelCreateUpdate;
